import ManagerList from "@/views/manager/ManagerList";
import ManagerEdit from "@/views/manager/ManagerEdit";
import ManagerAdd from "@/views/manager/ManagerAdd";

const routes = [
 {
    path: '/Manager/List',
    name: 'ManagerList',
    component: ManagerList,
    meta:{requiredAuth:true}
  },
  {
    path: '/Manager/Edit/:id',
    name: 'ManagerEdit',
    component: ManagerEdit,
    meta:{requiredAuth:true}
  },
  {
    path: '/Manager/Add',
    name: 'ManagerAdd',
    component: ManagerAdd,
    meta:{requiredAuth:true}
  },
]

export default routes